import { useTranslation } from 'react-i18next';

export const keyPrefix = 'user_list_list';
export const useUserListListTranslation = () => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Списки',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Lists',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Listas',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Listas',
  },
}) as Record<string, unknown>;
